import React, { ReactNode } from 'react';
import { IAuth, IAuthContextProps, IUser } from '../../models/IAuthModel';

export const AuthContext = React.createContext({} as IAuthContextProps);

export const userReducer = (state: IAuth, action: { type: string, payload: IAuth }) => {
    switch (action.type) {
        case 'SET_AUTH': {
            return action.payload;
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
};
const AuthProvider = ({ children }: { children: ReactNode}) => {
    let token: string | null = '';
    let user: IUser | null = null;

    if (typeof window !== 'undefined') {
        token = window.localStorage.getItem('token');
        const jsonUser = window.localStorage.getItem('user');
        if (jsonUser) {
            user = JSON.parse(jsonUser);
        }
    }

    const [state, dispatch] = React.useReducer(userReducer, { user, token, isAuthenticated: !!(user?.id?.length && token?.length) });

    const signIn = (username: string, password: string) => {
        const user = {
            id: username,
        };
        if ((username === 'admin' && password === 'admin')
         || (username === 'doctor' && password === 'doctor')
         || (username === 'nurse' && password === 'nurse')
        ) {
            const isAuthenticated = true;
            const token = password;
            const userRole = username;

            window.localStorage.setItem('userRole', userRole);
            window.localStorage.setItem('token', token);
            window.localStorage.setItem('user', JSON.stringify(user));

            dispatch({
                type: 'SET_AUTH',
                payload: { isAuthenticated, user, token },
            });
        } else {
            alert('Invalid Username & Password');
        }
    };

    const signOut = () => {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('userRole');
        window.localStorage.removeItem('user');
        dispatch({
            type: 'SET_AUTH',
            payload: { isAuthenticated: false, user: null, token: null },
        });
    };
    const profile = () => {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('user');
        dispatch({
            type: 'SET_AUTH',
            payload: { isAuthenticated: false, user: null, token: null },
        });
    };

    // NOTE: you *might* need to memoize this value
    // Learn more in http://kcd.im/optimize-context
    const value = {
        auth: state, signIn, signOut, profile,
    };
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
